import React, { useContext } from 'react';

import { HeaderContext } from '../HeaderContext';

import { track } from '../../../services/analytics';

import { Wallet } from '../../Icons';

import styles from './MainMenu.module.scss';

export const MainMenu: React.FC = () => {
  const { isAuthenticated, menuItems, walletAmount } = useContext(HeaderContext);

  const trackMenu = (category: string, action: string, label: string) => {
    track({
      event: 'gym_spa',
      category: category,
      action: action,
      label: label,
    });
  };

  return (
    <div className={`${styles['main-menu']} ${isAuthenticated ? styles['main-menu--loggedin'] : ''}`}>
      <ul className={styles['main-menu__list']}>
        {walletAmount > 0 && isAuthenticated && (
          <li className={`${styles['main-menu__item']} ${styles['main-menu__item--wallet']}`}>
            Your balance: <Wallet /> &pound;{walletAmount}
          </li>
        )}
        {menuItems.map((item, idx) => (
          <li key={`menu-item-${idx}`} className={styles['main-menu__item']}>
            {item.action ? (
              <button
                type="button"
                className={styles['main-menu__link']}
                onClick={() => {
                  trackMenu(item.trackingCategory, item.trackingAction, item.trackingLabel);
                  item.action && item.action();
                }}
              >
                {item.label}
              </button>
            ) : (
              <a
                href={item.link}
                className={styles['main-menu__link']}
                onClick={() => {
                  trackMenu(item.trackingCategory, item.trackingAction, item.trackingLabel);
                }}
              >
                {item.label}
              </a>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};
